export default __webpack_public_path__ + "static/media/rev.aef65803.png";